import checkFormat from '@/utils/checkFormat.js'
import api from '@/api/api.js'
import { Toast } from 'vant'
export const relateMixin = {
  data() {
    return {}
  },
  methods: {
    // 订单详情展示
    show() {
      if (this.$store.state.baseInfo && this.$store.state.carOwnerInfo !== null && this.$store.state.carOwnerInfo !== '') {
        if (this.$store.state.baseInfo.saveCustomerFlag === '1') {
          this.choose = true
        } else if (this.$store.state.baseInfo.saveCustomerFlag === '0') {
          this.choose = false
        }
      }
      this.condition = true
      if (this.$store.state.carOwnerInfo !== '' && this.$store.state.carOwnerInfo !== undefined && this.$store.state.carOwnerInfo !== null) {
        if (this.$store.state.carOwnerInfo.carOwner && this.$store.state.carOwnerInfo.carOwner !== '' && this.$store.state.carOwnerInfo.carOwner !== null) {
          for (const i in this.$store.state.carOwnerInfo) {
            if (this.$store.state.carOwnerInfo[i] !== null) {
              console.log(this.$store.state.comCode.startsWith('237'), i === 'carOwner', this.$store.state.carOwnerInfo[i], this.$store.state.carOwnerInfo[i].length > 4, this.$store.state.carOwnerInfo[i].indexOf('公司') !== -1)
              if (this.$store.state.comCode.startsWith('237') && i === 'carOwner' && this.$store.state.carOwnerInfo[i] && this.$store.state.carOwnerInfo[i].length > 4 && this.$store.state.carOwnerInfo[i].indexOf('公司') !== -1) {
                this.carOwnerInfo.vehicleOwnerNature = '3'
                this.condition = false
                this.getNatureStatus('3', 'A')
              }
              this.carOwnerInfo[i] = this.$store.state.carOwnerInfo[i]
            } else {
              this.carOwnerInfo[i] = ''
            }
          }
          this.conditions = 0
          // 车主身份类型
          switch (this.$store.state.carOwnerInfo.ownerIdentifyType) {
            case '01':
              this.ownerIdentifyType = '身份证'
              this.isShowCarMessage = true
              break
            case '02':
              this.ownerIdentifyType = '护照'
              this.isShowCarMessage = false
              break
            case '03':
              this.ownerIdentifyType = '军人证'
              this.isShowCarMessage = false
              break
            case '10':
              this.ownerIdentifyType = '组织机构代码'
              this.isShowCarMessage = false
              break
            case '11':
              this.ownerIdentifyType = '工商注册号码'
              this.isShowCarMessage = false
              break
          }
        }
      }
      const insuredLists = this.$store.state.insuredList
      let applicantIn
      let recognizeeIn
      if (insuredLists.length > 0) {
        insuredLists.forEach(value => {
          if (value.insuredFlag === '2') {
            applicantIn = value
          } else if (value.insuredFlag === '1') {
            recognizeeIn = value
          }
        })
      }
      const carOwnerInfos = this.$store.state.carOwnerInfo
      // 投保人信息
      if (applicantIn !== '' && applicantIn !== undefined && applicantIn !== null) {
        if (applicantIn.insuredName && applicantIn.insuredName !== '' && applicantIn.insuredName !== null) {
          this.conditions = 0
          for (const index in applicantIn) {
            if (applicantIn[index] !== null) {
              this.applicantIn[index] = applicantIn[index]
            } else {
              this.applicantIn[index] = null
            }
          }
          if (!applicantIn.occupationCode) {
            this.applicantIn.occupationCode = '030199'
            this.applicantIn.occupationName = '其他办事人员'
          }
          if (applicantIn.insuredRelationship === '0' ||
            (
              carOwnerInfos.vehicleOwnerNature === applicantIn.insuredType &&
              carOwnerInfos.carOwner === applicantIn.insuredName &&
              carOwnerInfos.ownerIdentifyNumber === applicantIn.identifyNumber &&
              (applicantIn.insuredNature !== recognizeeIn.insuredNature ||
                applicantIn.insuredName !== recognizeeIn.insuredName ||
                applicantIn.identifyNumber !== recognizeeIn.identifyNumber)
            )
          ) {
            this.applicantInData = '同车主'
          } else if (applicantIn.insuredRelationship === '1' ||
            (carOwnerInfos.vehicleOwnerNature === applicantIn.insuredType &&
              carOwnerInfos.carOwner === applicantIn.insuredName &&
              carOwnerInfos.ownerIdentifyNumber === applicantIn.identifyNumber &&
              applicantIn.insuredNature === recognizeeIn.insuredNature &&
              applicantIn.insuredName === recognizeeIn.insuredName &&
              applicantIn.identifyNumber === recognizeeIn.identifyNumber)) {
            this.applicantInData = '同被保人'
          } else if (applicantIn.insuredRelationship === '2') {
            this.applicantInData = '其他'
          } else {
            // 续保若以上条件都不符合，则兼容处理
            this.applicantInData = '其他'
          }
        }
      }
      // 被保人信息
      if (recognizeeIn !== '' && recognizeeIn !== undefined && recognizeeIn !== null) {
        if (recognizeeIn.insuredName && recognizeeIn.insuredName !== '' && recognizeeIn.insuredName !== null) {
          this.conditions = 0
          switch (recognizeeIn.insuredRelationship) {
            case '3':
              this.recognizeeInData = '同车主'
              break
            case '4':
              this.recognizeeInData = '其他'
              break
          }
          for (const j in recognizeeIn) {
            if (recognizeeIn[j] !== null) {
              this.recognizeeIn[j] = recognizeeIn[j]
            } else {
              this.recognizeeIn[j] = null
            }
          }
          if (!recognizeeIn.occupationCode) {
            this.recognizeeIn.occupationCode = '030199'
            this.recognizeeIn.occupationName = '其他办事人员'
          }
        }
      }
      if (!insuredLists.length > 0 && carOwnerInfos.carOwner && carOwnerInfos.ownerAddress) {
        if (this.recognizeeInData === '同车主') {
          this.recognizeeIn.insuredName = this.carOwnerInfo.carOwner
          this.recognizeeIn.address = this.carOwnerInfo.ownerAddress
          this.recognizeeIn.longAddress = this.carOwnerInfo.ownerAddress
        }
        if (this.applicantInData === '同车主') {
          this.applicantIn.insuredName = this.carOwnerInfo.carOwner
          this.applicantIn.address = this.carOwnerInfo.ownerAddress
          this.applicantIn.longAddress = this.carOwnerInfo.ownerAddress
        }
      }
      this.identifyTypes()
      this.filterValiDate()
    },
    /**
     * 获取客户信息
     */
    getCutomer(e) {
      if (this.cuntomerFlag === 'car') { // 车主选择
        this.carOwnerInfo.carOwner = e.customerName
        this.carOwnerInfo.ownerIdentifyNumber = e.idNumber
        this.carOwnerInfo.ownerAddress = e.area
        this.ownerIdentifyType = e.identifyTypeName
        this.carOwnerInfo.ownerIdentifyType = e.identifyType
        this.dateOfBirth = e.birthDay
        this.carOwnerInfo.email = e.email
        this.carOwnerInfo.mobile = e.phoneNumber
        this.validDate = e.validDate
      } else if (this.cuntomerFlag === 'recognizeeIn') { // 被保人选择
        this.recognizeeIn.insuredName = e.customerName
        this.RidentifyType = e.identifyTypeName
        this.recognizeeIn.identifyType = e.identifyType
        this.recognizeeIn.identifyNumber = e.idNumber
        this.recognizeeIn.mobile = e.phoneNumber
        this.recognizeeIn.email = e.email
        this.recognizeeIn.address = e.area
        this.recognizeeIn.longAddress = e.area
        this.recognizeeIn.validDate = e.validDate
        this.recognizeeIn.birthday = e.birthDay
      } else if (this.cuntomerFlag === 'applicantIn') { // 投保人选择
        this.applicantIn.insuredName = e.customerName
        this.AidentifyType = e.identifyTypeName
        this.applicantIn.identifyType = e.identifyType
        this.applicantIn.identifyNumber = e.idNumber
        this.applicantIn.mobile = e.phoneNumber
        this.applicantIn.email = e.email
        this.applicantIn.address = e.area
        this.applicantIn.longAddress = e.area
        this.applicantIn.validDate = e.validDate
        this.applicantIn.birthday = e.birthDay
      }
      this.assignment()
      this.recognizeeInassignment()
    },
    /**
     * watch 同车主监听赋值
     */
    assignment() {
      if (this.recognizeeInData === '同车主') { // 被保人同车主信息
        this.RidentifyType = this.ownerIdentifyType
        this.recognizeeIn.insuredName = this.carOwnerInfo.carOwner
        if (this.carOwnerInfo.vehicleOwnerNature === '1') {
          this.recognizeeIn.insuredNature = '3'
        } else if (this.carOwnerInfo.vehicleOwnerNature === '3') {
          this.recognizeeIn.insuredNature = '4'
        }
        this.recognizeeIn.identifyNumber = this.carOwnerInfo.ownerIdentifyNumber
        this.recognizeeIn.mobile = this.carOwnerInfo.mobile
        this.recognizeeIn.email = this.carOwnerInfo.email
        this.recognizeeIn.address = this.carOwnerInfo.ownerAddress
        this.recognizeeIn.longAddress = this.carOwnerInfo.ownerAddress
        this.gender.forEach(value => {
          if (value.codecname === this.sex) {
            this.recognizeeIn.sex = value.codeCode
            this.sex = value.codecname
          }
        })
        if (this.RidentifyType === '身份证') {
          this.recognizeeIn.birthday = checkFormat.identifyNumberToBirthday(this.recognizeeIn.identifyNumber)
        }
      }
      if (this.applicantInData === '同车主') { // 投保人同车主信息
        this.AidentifyType = this.ownerIdentifyType
        this.applicantIn.insuredName = this.carOwnerInfo.carOwner
        if (this.carOwnerInfo.vehicleOwnerNature === '1') {
          this.applicantIn.insuredNature = '3'
        } else if (this.carOwnerInfo.vehicleOwnerNature === '3') {
          this.applicantIn.insuredNature = '4'
        }
        this.applicantIn.identifyNumber = this.carOwnerInfo.ownerIdentifyNumber
        this.applicantIn.mobile = this.carOwnerInfo.mobile
        this.applicantIn.email = this.carOwnerInfo.email
        this.applicantIn.address = this.carOwnerInfo.ownerAddress
        this.applicantIn.longAddress = this.carOwnerInfo.ownerAddress
        this.gender.forEach(value => {
          if (value.codecname === this.sex) {
            this.applicantIn.sex = value.codeCode
            this.sexs = value.codecname
          }
        })
        if (this.AidentifyType === '身份证') {
          this.applicantIn.birthday = checkFormat.identifyNumberToBirthday(this.applicantIn.identifyNumber)
        }
      }
      this.filterValiDate()
    },
    /**
     * watch 监听 同被保人赋值
     */
    recognizeeInassignment() {
      if (this.applicantInData === '同被保人') { // 投保人同被保人
        this.AidentifyType = this.RidentifyType
        this.applicantIn.insuredName = this.recognizeeIn.insuredName
        this.applicantIn.identifyType = this.recognizeeIn.identifyType
        this.applicantIn.identifyNumber = this.recognizeeIn.identifyNumber
        this.applicantIn.mobile = this.recognizeeIn.mobile
        this.applicantIn.email = this.recognizeeIn.email
        this.applicantIn.address = this.recognizeeIn.address
        this.applicantIn.longAddress = this.recognizeeIn.longAddress
        this.AunitNature = this.RunitNature
        // this.applicantIn.validDate = this.recognizeeIn.validDate
        // this.applicantInData.iDStartDate = this.recognizeeIn.iDStartDate
        this.applicantIn.insuredNature = this.recognizeeIn.insuredNature
        if (this.AidentifyType === '身份证') {
          this.applicantIn.birthday = checkFormat.identifyNumberToBirthday(this.applicantIn.identifyNumber)
          this.applicantIn.validDate = this.recognizeeIn.validDate
          this.applicantIn.iDStartDate = this.recognizeeIn.iDStartDate
        } else {
          this.applicantIn.birthday = this.recognizeeIn.birthday
        }
        this.applicantIn.occupationName = this.recognizeeIn.occupationName
        this.applicantIn.occupationCode = this.recognizeeIn.occupationCode
      }
    },
    // 下一步再清除多余参数
    clearNatureStatus() {
      if (this.recognizeeIn.insuredNature === '3') {
        this.recognizeeIn.businessSort = ''
      } else {
        this.sex = ''
        this.recognizeeIn.sex = ''
        this.recognizeeIn.birthday = ''
        this.recognizeeIn.validDate = ''
      }
      if (this.applicantIn.insuredNature === '3') {
        this.applicantIn.businessSort = ''
      } else {
        this.sexs = ''
        this.applicantIn.sex = ''
        this.applicantIn.birthday = ''
        this.applicantIn.validDate = ''
      }
    },
    /**
     * 切换车主性质（'A'），被保人性质（'B'）,投保人性质（'C'）
     */
    getNatureStatus(num, state) {
      if (state === 'A') {
        this.carOwnerInfo.vehicleOwnerNature = num
        if (this.carOwnerInfo.vehicleOwnerNature === '1') {
          if (this.recognizeeInData === '同车主') {
            this.RunitNature = ''
            // this.recognizeeIn.businessSort = ''
            this.RidentifyType = '身份证'
            this.recognizeeIn.identifyType = '01'
            this.recognizeeIn.insuredNature = '3'
            this.recognizeeIn.insuredType = '1'
            // this.recognizeeIn.birthday = ''
          }
          if (this.applicantInData === '同车主') {
            this.AunitNature = ''
            // this.applicantIn.businessSort = ''
            this.AidentifyType = '身份证'
            this.applicantIn.identifyType = '01'
            this.applicantIn.insuredNature = '3'
            this.applicantIn.insuredType = '1'
            // this.applicantIn.birthday = ''
          }
          this.ownerIdentifyType = '身份证'
          this.carOwnerInfo.ownerIdentifyType = '01'
          // this.carOwnerInfo.ownerIdentifyNumber = ''
          this.isShowCarMessage = true
          this.textCarName = '车主姓名'
          this.textCarDesc = '请输入车主姓名'
          this.textCarPhoneDesc = '请输入手机号码'
          this.textCarPhone = '手机号码'
          this.textCarAddressDesc = '请输入家庭地址'
          this.textCarAddress = '家庭地址'
        } else {
          if (this.recognizeeInData === '同车主') {
            this.RunitNature = '党政机关'
            this.recognizeeIn.businessSort = '16'
            this.RidentifyType = '组织机构代码证'
            this.recognizeeIn.identifyType = '10'
            // this.sex = ''
            // this.recognizeeIn.sex = ''
            this.recognizeeIn.insuredNature = '4'
            this.recognizeeIn.insuredType = '2'
            // this.recognizeeIn.birthday = ''
          }

          if (this.applicantInData === '同车主') {
            this.AunitNature = '党政机关'
            this.applicantIn.businessSort = '16'
            this.AidentifyType = '组织机构代码证'
            this.applicantIn.identifyType = '10'
            // this.sexs = ''
            // this.applicantIn.sex = ''
            this.applicantIn.insuredNature = '4'
            this.applicantIn.insuredType = '2'
            // this.applicantIn.birthday = ''
          }
          this.ownerIdentifyType = '组织机构代码'
          this.carOwnerInfo.ownerIdentifyType = '10'
          // this.carOwnerInfo.ownerIdentifyNumber = ''
          this.isShowCarMessage = false
          this.textCarName = '车主名称'
          this.textCarDesc = '请输入车主名称'
          this.textCarPhoneDesc = '请输入联系方式'
          this.textCarPhone = '联系方式'
          this.textCarAddressDesc = '请输入详细地址'
          this.textCarAddress = '详细地址'
        }
      } else if (state === 'B') {
        this.recognizeeIn.insuredNature = num
        if (this.recognizeeIn.insuredNature === '3') {
          this.RunitNature = ''
          this.recognizeeIn.businessSort = ''
          this.recognizeeIn.identifyNumber = ''
          this.recognizeeIn.birthday = ''
          this.RidentifyType = '身份证'
          this.recognizeeIn.identifyType = '01'
          this.recognizeeIn.insuredType = '1'
          this.textRecognizeeInMoblie = '手机号码'
          this.textRecognizeeInMoblieDesc = '请输入手机号码'
        } else {
          this.RunitNature = '党政机关'
          this.recognizeeIn.businessSort = '16'
          this.RidentifyType = '统一社会信用代码'
          this.recognizeeIn.identifyNumber = ''
          this.recognizeeIn.birthday = ''
          this.recognizeeIn.identifyType = '13'
          this.recognizeeIn.insuredType = '2'
          this.textRecognizeeInMoblie = '联系方式'
          this.textRecognizeeInMoblieDesc = '请输入联系方式'
          this.sex = ''
          this.recognizeeIn.sex = ''
        }
        if (this.applicantInData === '同被保人') {
          if (this.recognizeeIn.insuredNature === '3') {
            this.applicantIn.insuredNature = '3'
            this.applicantIn.insuredType = '1'
          } else {
            this.applicantIn.insuredNature = '4'
            this.applicantIn.insuredType = '2'
            this.sexs = ''
            this.applicantIn.sex = ''
          }
          this.applicantIn.birthday = ''
        }
      } else if (state === 'C') {
        this.applicantIn.insuredNature = num
        if (this.applicantIn.insuredNature === '3') {
          this.AunitNature = ''
          this.applicantIn.businessSort = ''
          this.AidentifyType = '身份证'
          this.applicantIn.identifyNumber = ''
          this.applicantIn.birthday = ''
          this.applicantIn.identifyType = '01'
          this.textApplicantInMobileMessage = '请输入手机号码'
          this.textApplicantInMobile = '手机号码'
          this.applicantIn.insuredType = '1'
        } else {
          this.AunitNature = '党政机关'
          this.applicantIn.businessSort = '16'
          this.AidentifyType = '统一社会信用代码'
          this.applicantIn.identifyNumber = ''
          this.applicantIn.birthday = ''
          this.applicantIn.identifyType = '13'
          this.textApplicantInMobileMessage = '请输入手机号码'
          this.textApplicantInMobile = '手机号码'
          this.sexs = ''
          this.applicantIn.sex = ''
          this.applicantIn.insuredType = '2'
        }
      }
    },
    // 确定按钮
    onConfirm(value) {
      console.log(this.status, '====')
      if (this.status === 'r') { // 选择被保人类型
        this.recognizeeIn.insuredRelationship = value.code
        this.recognizeeInData = value.text
        if (this.recognizeeInData === '其他') {
          this.isShowOcrInsured = true
        } else {
          this.isShowOcrInsured = false
          this.assignment()
        }
        this.popupShow = false
        this.showInfo1 = true
      } else if (this.status === 'a') { // 选择投保人类型
        this.applicantIn.insuredRelationship = value.code
        this.applicantInData = value.text
        if (this.applicantInData === '其他') {
          this.isShowOcrInsuredApplicant = true
        } else {
          this.isShowOcrInsuredApplicant = false
          if (this.applicantInData === '同车主') { // 投保人同车主信息
            this.assignment()
          } else {
            this.recognizeeInassignment()
          }
          this.filterValiDate()
        }
        this.popupShow = false
        this.showInfo2 = true
      } else if (this.status === 'IdentifyType0') { // 选择车主证件类型
        this.ownerIdentifyType = value.text
        this.carOwnerInfo.ownerIdentifyType = value.code
        if (this.recognizeeInData === '同车主') {
          if (value.code === '01') {
            this.RidentifyType = value.text
            this.recognizeeIn.identifyType = value.code
          } else if (value.code === '02') {
            this.RidentifyType = '中国护照'
            this.recognizeeIn.identifyType = '03'
          } else if (value.code === '03') {
            this.RidentifyType = '军官证'
            this.recognizeeIn.identifyType = '04'
          } else if (value.code === '10') {
            this.RidentifyType = '组织机构代码证'
            this.recognizeeIn.identifyType = '10'
          } else if (value.code === '11') {
            this.RidentifyType = '工商营业执照'
            this.recognizeeIn.identifyType = '11'
          }
        }
        if (this.applicantInData === '同车主') {
          if (value.code === '01') {
            this.AidentifyType = value.text
            this.applicantIn.identifyType = value.code
          } else if (value.code === '02') {
            this.AidentifyType = '中国护照'
            this.applicantIn.identifyType = '03'
          } else if (value.code === '03') {
            this.AidentifyType = '军官证'
            this.applicantIn.identifyType = '04'
          } else if (value.code === '10') {
            this.AidentifyType = '组织机构代码证'
            this.applicantIn.identifyType = '10'
          } else if (value.code === '11') {
            this.AidentifyType = '工商营业执照'
            this.applicantIn.identifyType = '11'
          }
        }
        this.isShowCarMessage = value.text === '身份证'
        this.popupShow = false
      } else if (this.status === 'IdentifyType1') { // 选择被保人证件类型
        this.RidentifyType = value.text
        this.recognizeeIn.identifyType = value.code
        this.popupShow = false
      } else if (this.status === 'IdentifyType2') { // 选择投保人证件类型
        this.AidentifyType = value.text
        this.applicantIn.identifyType = value.code
        this.popupShow = false
      } else if (this.status === 'IdentifyType3') { // 选择被保人单位性质
        this.RunitNature = value.text
        this.recognizeeIn.businessSort = value.code
        this.popupShow = false
      } else if (this.status === 'IdentifyType4') { // 选择投保人单位性质
        this.AunitNature = value.text
        this.applicantIn.businessSort = value.code
        this.popupShow = false
      } else if (this.status === '1') { // 被保人出生日期
        this.dateShow = false
        this.recognizeeIn.birthday = checkFormat.getTimeToDate(value)
      } else if (this.status === '2') { // 投保人出生日期
        this.dateShow = false
        this.applicantIn.birthday = checkFormat.getTimeToDate(value)
      } else if (this.status === '3') { // 被保人证件有效期
        this.valDateShow = false
        this.recognizeeIn.validDate = checkFormat.getTimeToDate(value)
      } else if (this.status === '4') { // 投保人证件有效期
        this.valDateShow = false
        this.applicantIn.validDate = checkFormat.getTimeToDate(value)
      } else if (this.status === '5') { // 投保人证件有效起期
        this.valDateShow = false
        this.recognizeeIn.iDStartDate = checkFormat.getTimeToDate(value)
      } else if (this.status === '6') { // 被保人证件有效起期
        this.valDateShow = false
        this.applicantIn.iDStartDate = checkFormat.getTimeToDate(value)
      } else if (this.status === 'sex0') { // 被保人性别
        if (this.RidentifyType === '身份证') {
          if (parseInt(this.recognizeeIn.identifyNumber.substr(16, 1)) % 2 === 1 && value.code === '2') {
            this.$toast('性别与身份证不一致')
            this.popupShow = false
            return
          }
          if (parseInt(this.recognizeeIn.identifyNumber.substr(16, 1)) % 2 === 0 && value.code === '1') {
            this.$toast('性别与身份证不一致')
            this.popupShow = false
            return
          }
        }
        this.popupShow = false
        this.sex = value.text
        this.recognizeeIn.sex = value.code
      } else if (this.status === 'sex1') { // 投保人性别
        if (this.AidentifyType === '身份证') {
          if (parseInt(this.applicantIn.identifyNumber.substr(16, 1)) % 2 === 1 && value.code === '2') {
            this.$toast('性别与身份证不一致')
            this.popupShow = false
            return
          }
          if (parseInt(this.applicantIn.identifyNumber.substr(16, 1)) % 2 === 0 && value.code === '1') {
            this.$toast('性别与身份证不一致')
            this.popupShow = false
            return
          }
        }
        this.popupShow = false
        this.sexs = value.text
        this.applicantIn.sex = value.code
      }
    },
    /**
     * 暂存接口
     */
    saveMessage(type) {
      // 校验车主信息
      if (this.carOwnerInfo.carOwner === '' || this.carOwnerInfo.carOwner === null) {
        this.$toast('请输入车主姓名')
        return false
      } else if (this.carOwnerInfo.ownerIdentifyNumber === '' || this.carOwnerInfo.ownerIdentifyNumber === null) {
        this.$toast('请输入车主证件号码')
        return false
      } else if (this.carOwnerInfo.mobile === '' || this.carOwnerInfo.mobile === null) {
        this.$toast('请输入车主手机号码')
        return false
      }
      // 校验被保人信息
      if (this.recognizeeIn.insuredName === '' || this.recognizeeIn.insuredName === null) {
        this.$toast('请输入被保人姓名')
        return false
      } else if (this.recognizeeIn.identifyNumber === '' || this.recognizeeIn.identifyNumber === null) {
        this.$toast('请输入被保人证件号码')
        return false
      } else if (this.recognizeeIn.mobile === '' || this.recognizeeIn.mobile === null) {
        this.$toast('请输入被保人手机号码')
        return false
      } else if (this.RidentifyType === '身份证' && this.recognizeeIn.insuredNature === '3') {
        if (this.recognizeeIn.iDStartDate === '' || this.recognizeeIn.iDStartDate === null) {
          this.$toast('请选择被保人证件有效起期')
          return false
        }
        if (this.recognizeeIn.validDate === '' || this.recognizeeIn.validDate === null) {
          this.$toast('请选择被保人证件有效止期')
          return false
        }
      } else if (this.recognizeeIn.insuredNature === '3' && (this.recognizeeIn.birthday === '' || this.recognizeeIn.birthday === null)) {
        this.$toast('请选择被保人出生日期')
        return false
      } else if (this.recognizeeIn.address === '' || this.recognizeeIn.address === null) {
        this.$toast('请输入被保人地址')
        return false
      } else if (this.recognizeeIn.insuredNature === '3' && (this.recognizeeIn.sex === '' || this.recognizeeIn.sex == null)) {
        this.$toast('被保人性别不能为空')
        return false
      } else if (this.recognizeeIn.longAddress === '' || this.recognizeeIn.longAddress === null) {
        this.$toast('请输入被保人长久居住地')
        return false
      }
      // 校验投保人信息
      if (this.applicantIn.insuredName === '' || this.applicantIn.insuredName === null) {
        this.$toast('请输入投保人姓名')
        return false
      } else if (this.applicantIn.identifyNumber === '' || this.applicantIn.identifyNumber === null) {
        this.$toast('请输入投保人证件号码')
        return false
      } else if (this.applicantIn.mobile === '' || this.applicantIn.mobile === null) {
        this.$toast('请输入投保人手机号码')
        return false
      } else if (this.AidentifyType === '身份证' && this.applicantIn.insuredNature === '3') {
        if (this.applicantIn.iDStartDate === '' || this.applicantIn.iDStartDate === null) {
          this.$toast('请选择投保人证件有起效期')
          return false
        }
        if (this.applicantIn.validDate === '' || this.applicantIn.validDate === null) {
          this.$toast('请选择投保人证件有效止期')
          return false
        }
      } else if (this.applicantIn.insuredNature === '3' && (this.applicantIn.birthday === '' || this.applicantIn.birthday === null)) {
        this.$toast('请选择投保人出生日期')
        return false
      } else if (this.applicantIn.address === '' || this.applicantIn.address === null) {
        this.$toast('请输入投保人地址')
        return false
      } else if (this.applicantIn.longAddress === '' || this.applicantIn.longAddress === null) {
        this.$toast('请输入投保人长久居住地')
        return false
      }
      if (this.recognizeeIn.insuredNature === '4') {
        if (this.recognizeeIn.linkerName === '' || this.recognizeeIn.linkerName === null) {
          this.$toast('请输入联系人名称')
          return false
        }
      }
      if (this.recognizeeIn.birthday !== '' && this.recognizeeIn.insuredNature === '3') {
        if (checkFormat.getDate(this.recognizeeIn.birthday) === 'NaN-NaN-NaN NaN时') {
          this.$toast('被保人出生日期不能小于1或大于当前月的最大天数')
          return false
        }
      }
      if (this.applicantIn.birthday !== '' && this.applicantIn.insuredNature === '3') {
        if (checkFormat.getDate(this.applicantIn.birthday) === 'NaN-NaN-NaN NaN时') {
          this.$toast('投保人出生日期不能小于1或大于当前月的最大天数')
          return false
        }
      }
      if (this.recognizeeIn.validDate !== '' && this.recognizeeIn.insuredNature === '3') {
        if (checkFormat.getDate(this.recognizeeIn.validDate) === 'NaN-NaN-NaN NaN时') {
          this.$toast('被保人证件有效期不能小于1或大于当前月的最大天数')
          return false
        }
      }
      if (this.applicantIn.validDate !== '' && this.applicantIn.insuredNature === '3') {
        if (checkFormat.getDate(this.applicantIn.validDate) === 'NaN-NaN-NaN NaN时') {
          this.$toast('投保人证件有效期不能小于1或大于当前月的最大天数')
          return false
        }
      }
      if (this.recognizeeIn.identifyNumber === '' && this.recognizeeIn.insuredNature === '3') {
        this.$toast('被保人性别不能为空')
        return false
      }
      if (this.applicantIn.identifyNumber === '' && this.applicantIn.insuredNature === '3') {
        this.$toast('投保人性别不能为空')
        return false
      }
      if (this.recognizeeIn.sex !== null && this.recognizeeIn.sex !== '' && this.recognizeeIn.identifyNumber !== null && this.recognizeeIn.identifyNumber !== '' && this.recognizeeIn.insuredNature === '3') {
        if (parseInt(this.recognizeeIn.identifyNumber.substr(16, 1)) % 2 === 1 && this.recognizeeIn.sex === '2') {
          this.$toast('被保人证件与性别不一致')
          return false
        }
        if (parseInt(this.recognizeeIn.identifyNumber.substr(16, 1)) % 2 === 0 && this.recognizeeIn.sex === '1') {
          this.$toast('被保人证件与性别不一致')
          return false
        }
      }
      if (this.applicantIn.sex !== null && this.applicantIn.sex !== '' && this.applicantIn.identifyNumber !== null && this.applicantIn.identifyNumber !== '' && this.applicantIn.insuredNature === '3') {
        if (parseInt(this.applicantIn.identifyNumber.substr(16, 1)) % 2 === 1 && this.applicantIn.sex === '2') {
          this.$toast('投保人证件与性别不一致')
          return false
        }
        if (parseInt(this.applicantIn.identifyNumber.substr(16, 1)) % 2 === 0 && this.applicantIn.sex === '1') {
          this.$toast('投保人证件与性别不一致')
          return false
        }
      }
      this.clearNatureStatus()
      if (!this.checkEmail(this.carOwnerInfo.email, true)) {
        return false
      }
      if (!this.checkEmail(this.recognizeeIn.email, true)) {
        return false
      }
      if (!this.checkEmail(this.applicantIn.email, true)) {
        return false
      }
      if (!this.checkAddress(this.carOwnerInfo.ownerAddress, true)) {
        return false
      }
      if (!this.checkAddress(this.recognizeeIn.address, true)) {
        return false
      }
      if (!this.checkAddress(this.recognizeeIn.longAddress, true)) {
        return false
      }
      if (!this.checkAddress(this.applicantIn.address, true)) {
        return false
      }
      if (!this.checkAddress(this.applicantIn.longAddress, true)) {
        return false
      }
      if (!this.checkPhoneNum(this.carOwnerInfo.mobile, true)) {
        return false
      }
      if (!this.checkPhoneNum(this.recognizeeIn.mobile, true)) {
        return false
      }
      if (!this.checkPhoneNum(this.applicantIn.mobile, true)) {
        return false
      }
      if (!this.checkIdentityNumber(this.ownerIdentifyType, this.carOwnerInfo.ownerIdentifyNumber, true)) {
        return false
      }
      if (!this.checkIdentityNumber(this.RidentifyType, this.recognizeeIn.identifyNumber, true)) {
        return false
      }
      if (!this.checkIdentityNumber(this.AidentifyType, this.applicantIn.identifyNumber, true)) {
        return false
      }
      this.switchs = true
      this.$store.commit('setCarOwnerInfo', this.carOwnerInfo)
      this.$store.commit('setApplicantIn', this.applicantIn)
      this.$store.commit('setRecognizeeIn', this.recognizeeIn)
      this.insuredList = []
      this.insuredList.push(this.applicantIn)
      this.insuredList.push(this.recognizeeIn)
      const JQfile = {
        businessNo: 10501237000019000000,
        riskCode: '0501'
      }
      if (this.imgobjs.length > 0) {
        const imageInfoLists = []
        if (this.$store.state.itemFileDataList.length > 0 && this.$store.state.itemFileDataList[0].fileList.length > 0 && this.$store.state.itemFileDataList[0].fileList[0].fileId !== '') {
          this.$store.state.itemFileDataList[0].fileList.forEach(value => {
            imageInfoLists.push({
              fileId: value.fileId,
              fileType: value.fileType
            })
          })
        }
        this.imgobjs.forEach(value => {
          imageInfoLists.push({
            fileId: value.fileId,
            fileType: value.fileType
          })
        })
        if (imageInfoLists.length !== 0) {
          JQfile.fileList = imageInfoLists
        }
      }
      const params = {
        carOwnerInfo: this.carOwnerInfo, // 车主信息
        vehicleInfo: this.$store.state.vehicleInfos, // 车辆信息
        insuredList: this.insuredList,
        userId: 'gsd3sd1f321',
        productName: '001',
        riskCode: '0505',
        orderId: this.$store.state.orderId, // 订单id
        insuranceSign: '0',
        proposalAreaCode: this.$store.state.proposalAreaCode,
        proposalCityCode: this.$store.state.proposalCityCode,
        insurer: '1050',
        terminalId: localStorage.getItem('setTerminalId'),
        orderOrigin: localStorage.getItem('setChannelCode'),
        channelCode: localStorage.getItem('setChannelCode'),
        productCode: 'CAR20190517', // 产品代码，暂时写这个
        terminalIdType: checkFormat.getPhoneLike()
      }
      if (this.$store.state.baseInfo) {
        params.baseInfo = this.$store.state.baseInfo
        params.baseInfo.cityCode = this.$store.state.proposalCityCode
        params.baseInfo.provinceCode = this.$store.state.proposalAreaCode
      } else {
        params.baseInfo = {
          cityCode: this.$store.state.proposalCityCode,
          provinceCode: this.$store.state.proposalAreaCode
        }
      }
      if (this.choose) {
        params.baseInfo.saveCustomerFlag = '1'
      } else {
        params.baseInfo.saveCustomerFlag = '0'
      }
      if (this.$store.state.userCode !== null && this.$store.state.userCode !== '') {
        params.baseInfo.introduceCode = this.$store.state.userCode
      }
      if (this.$store.state.userName !== null && this.$store.state.userName !== '') {
        params.baseInfo.introduceName = this.$store.state.userName
      }
      if (this.$store.state.introduceAgreementNo !== null && this.$store.state.introduceAgreementNo !== '') {
        params.baseInfo.introduceAgreementNo = this.$store.state.introduceAgreementNo
      }
      if (JQfile.fileList) {
        const JQfiles = []
        JQfiles.push(JQfile)
        params.itemFileDataList = JQfiles
      }
      this.$http.post(api.save, params)
        .then(res => {
          Toast.clear()
          if (res.data.rtnCode === '0000') {
            this.$store.commit('setBaseInfo', params.baseInfo)
            if (this.imgobjs.length > 0) {
              this.$store.commit('setItemFileDataList', res.data.resultObj.itemFileDataList)
            }
            this.imgobjs = []
            if (this.choose && this.network) {
              const data = {
                carOwnerInfo: this.carOwnerInfo, // 车主信息
                insuredList: this.insuredList // 投被保人信息
              }
              this.$http.post(api.saveCustomerInfo, data)
                .then(EL => {
                  this.switchs = false
                  if (EL.data.rtnCode === '0000') {
                    if (type === 1) { // 点击的是投保按钮
                      this.$store.commit('setStep', '3')
                      this.$store.commit('setInsuredList', this.insuredList)
                    } else {
                      this.$toast('暂存成功')
                    }
                  } else {
                    this.$toast('请求失败')
                  }
                })
                .catch(err => {
                  this.$toast('请求失败')
                  console.log(err)
                  this.switchs = false
                })
            } else {
              this.switchs = false
              if (type === 1) { // 点击的是投保按钮
                this.$store.commit('setStep', '3')
                this.$store.commit('setInsuredList', this.insuredList)
              } else {
                this.$toast('暂存成功')
              }
            }
          } else {
            this.switchs = false
            Toast.clear()
            this.$toast(res.data.rtnMsg)
          }
        })
        .catch(err => {
          this.$toast('请求失败')
          console.log(err)
          this.switchs = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/car/relate/Mixin/mixin.js